import { Box, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export const CardItem = styled(Box)(() => ({
    border: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
    padding: tokens.SizingSpacing200,
    background: tokens.ColorSurfaceDefault,
    borderRadius: tokens.SizingCornerL,
    width: '100%',
}))
